<div class="animated fadeIn">
	<!-- <h3>Admin Panel</h3>
	<br/> -->
	<div class="row">
		<div class="col-lg-12">
			<div class="card">
				<div class="card-body" style="min-height: 600px;">
					<h4 class="box-title">Email Settings </h4>
					<br/>
					
					<div style="border: 2px solid #dee2e6; padding: 10px; margin-top: 10px;" id="editCont0"> 
						<div class="row form-group">
							<div class="col col-md-5">
								{{allConfigData[0].title}}
							</div>
							<div class="col col-md-5">
								{{allConfigData[1].title}}
							</div>
							<div class="col col-md-2">
								&nbsp;
							</div>
						</div>
						<div class="row form-group">
							<div class="col col-md-5">
								<input name="config0"  id="config0" [(ngModel)]="allConfigVal[0]" class="form-control-sm form-control" required="" (keypress)="numberOnly($event)"  />{{allConfigData[0].keyUnit}}
							</div>
							<div class="col col-md-5">
								<input name="config1"  id="config1" [(ngModel)]="allConfigVal[1]" class="form-control-sm form-control" required="" (keypress)="numberOnly($event)"  />{{allConfigData[1].keyUnit}}
							</div>
							<div class="col col-md-2">
								<div class="form-actions form-group">
									<button type="submit" class="btn btn-primary btn-sm" (click)="updateAllConfig([[allConfigData[0].keyIndex,0],[allConfigData[1].keyIndex,1]])" >Update</button>
								</div>
							</div>
						</div>
					</div>
					<div style="border: 2px solid #dee2e6; padding: 10px; margin-top: 10px;" id="editCont1"> 
						<div class="row form-group">
							<div class="col col-md-5">
								{{allConfigData[2].title}}
							</div>
							<div class="col col-md-5">
								{{allConfigData[3].title}}
							</div>
							<div class="col col-md-2">
								&nbsp;
							</div>
						</div>
						<div class="row form-group">
							<div class="col col-md-5">
								<input name="config2"  id="config2" [(ngModel)]="allConfigVal[2]" class="form-control-sm form-control" required="" (keypress)="numberOnly($event)"  />{{allConfigData[2].keyUnit}}
							</div>
							<div class="col col-md-5">
								<input name="config3"  id="config3" [(ngModel)]="allConfigVal[3]" class="form-control-sm form-control" required="" (keypress)="numberOnly($event)"  />{{allConfigData[3].keyUnit}}
							</div>
							<div class="col col-md-2">
								<div class="form-actions form-group">
									<button type="submit" class="btn btn-primary btn-sm" (click)="updateAllConfig([[allConfigData[2].keyIndex,2],[allConfigData[3].keyIndex,3]])" >Update</button>
								</div>
							</div>
						</div>
					</div>
					<div style="border: 2px solid #dee2e6; padding: 10px; margin-top: 10px;" id="editCont2"> 
						<div class="row form-group">
							<div class="col col-md-5">
								{{allConfigData[4].title}}
							</div>
							<div class="col col-md-5">
								{{allConfigData[5].title}}
							</div>
							<div class="col col-md-2">
								&nbsp;
							</div>
						</div>
						<div class="row form-group">
							<div class="col col-md-5">
								<input name="config4"  id="config4" [(ngModel)]="allConfigVal[4]" class="form-control-sm form-control" required="" (keypress)="numberOnly($event)"  />{{allConfigData[4].keyUnit}}
							</div>
							<div class="col col-md-5">
								<input name="config5"  id="config5" [(ngModel)]="allConfigVal[5]" class="form-control-sm form-control" required="" (keypress)="numberOnly($event)"  />{{allConfigData[5].keyUnit}}
							</div>
							<div class="col col-md-2">
								<div class="form-actions form-group">
									<button type="sumit" class="btn btn-primary btn-sm" (click)="updateAllConfig([[allConfigData[4].keyIndex,4],[allConfigData[5].keyIndex,5]])" >Update</button>
								</div>
							</div>
						</div>
					</div>
					<div style="border: 2px solid #dee2e6; padding: 10px; margin-top: 10px;" id="editCont3"> 
						<div class="row form-group">
							<div class="col col-md-4">
								{{allConfigData[6].title}}
							</div>
							<div class="col col-md-6">
								{{allConfigData[7].title}}
							</div>
							<div class="col col-md-2">
								&nbsp;
							</div>
						</div>
						<div class="row form-group">
							<div class="col col-md-4">
								<input name="config6"  id="config6" [(ngModel)]="allConfigVal[6]" class="form-control-sm form-control" required="" (keypress)="numberOnly($event)"  />{{allConfigData[6].keyUnit}}
							</div>
							<div class="col col-md-6">
								<textarea name="config7"  id="config7" [(ngModel)]="allConfigVal[7]" class="form-control-sm form-control" required=""   ></textarea>{{allConfigData[7].keyUnit}}
							</div>
							<div class="col col-md-2">
								<div class="form-actions form-group">
									<button type="sumit" class="btn btn-primary btn-sm" (click)="updateAllConfig([[allConfigData[6].keyIndex,6],[allConfigData[7].keyIndex,7]])" >Update</button>
								</div>
							</div>
						</div>
					</div>
					<div style="border: 2px solid #dee2e6; padding: 10px; margin-top: 10px;" id="editCont4"> 
						<div class="row form-group">
							<div class="col col-md-4">
								{{allConfigData[8].title}}
							</div>
							<div class="col col-md-6">
								{{allConfigData[9].title}}
							</div>
							<div class="col col-md-2">
								&nbsp;
							</div>
						</div>
						<div class="row form-group">
							<div class="col col-md-4">
								<input name="config8"  id="config8" [(ngModel)]="allConfigVal[8]" class="form-control-sm form-control" required=""   />{{allConfigData[8].keyUnit}}
							</div>
							<div class="col col-md-6">
								<textarea name="config9"  id="config9" [(ngModel)]="allConfigVal[9]" class="form-control-sm form-control" required=""   ></textarea>{{allConfigData[9].keyUnit}}
							</div>
							<div class="col col-md-2">
								<div class="form-actions form-group">
									<button type="sumit" class="btn btn-primary btn-sm" (click)="updateAllConfig([[allConfigData[8].keyIndex,8],[allConfigData[9].keyIndex,9]])" >Update</button>
								</div>
							</div>
						</div>
					</div>
					<div style="border: 2px solid #dee2e6; padding: 10px; margin-top: 10px;" id="editCont5"> 
						<div class="row form-group">
							<div class="col col-md-4">
								{{allConfigData[10].title}}
							</div>
							<div class="col col-md-6">
								{{allConfigData[11].title}}
							</div>
							<div class="col col-md-2">
								&nbsp;
							</div>
						</div>
						<div class="row form-group">
							<div class="col col-md-4">
								<input name="config10"  id="config6" [(ngModel)]="allConfigVal[10]" class="form-control-sm form-control" required=""   />{{allConfigData[10].keyUnit}}
							</div>
							<div class="col col-md-6">
								<textarea name="config11"  id="config11" [(ngModel)]="allConfigVal[11]" class="form-control-sm form-control"   ></textarea>{{allConfigData[11].keyUnit}}
							</div>
							<div class="col col-md-2">
								<div class="form-actions form-group">
									<button type="sumit" class="btn btn-primary btn-sm" (click)="updateAllConfig([[allConfigData[10].keyIndex,10],[allConfigData[11].keyIndex,11]])" >Update</button>
								</div>
							</div>
						</div>
					</div>
					
				</div>
			</div>
		</div>
	</div>
</div><!-- .animated -->

